<div *ngIf="active">
  <div *ngIf="(companyList$ | async) as companyList; else loadingTemplate">
    <div class="form-group" *ngIf="companyList.length > 0; else noDataTemplate">
      <label [hidden]="hideLabel">{{ label }}</label>
      <ng-select required [items]="companyList" bindLabel="Name" [multiple]="false" [hideSelected]="true"
                 [loading]="companyListLoading" [typeahead]="companyListinput$" [(ngModel)]="selectedCompany"
                 name="SelectCompany"
                 placeholder="{{selectCompanyText}}" (change)=selectedCompanyChanged($event)>
      </ng-select>
    </div>
    <ng-template #noDataTemplate>
      There are no companies avaliable yet. Please create a valid company first.
    </ng-template>
  </div>
  <ng-template #loadingTemplate>
    There are no companies avaliable yet. Please create a valid company first.
  </ng-template>
</div>
